/*
 * Built with Common Launchpad 2.0.3
 */

import $ from 'jquery';

class VideoWidgetInline {
    constructor() {
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        // Title click
        $(document).on('click', '.js-inline-preview', e => {
            e.preventDefault();
            const inlineVideo = $(e.currentTarget);

            // Hide preview Image
            $(inlineVideo).hide();
            // Toggle content visibility
            $(inlineVideo).next('.js-inline-video').show();
        });

        $(document).on('click', '.js-video-click', e => {
            if (!e.currentTarget.paused) {
                e.currentTarget.pause();
                e.currentTarget.parentElement.lastElementChild.classList.remove('d-none');
            }
        });

        $(document).on('click', '.js-video-play', e => {
            if (e.currentTarget.parentElement.firstElementChild.paused) {
                e.currentTarget.parentElement.firstElementChild.play();
                e.currentTarget.className += ' d-none';
            }
        });

        $(document).on('keypress', '.js-inline-preview', e => {
            e.preventDefault();
            if (e.which === 13) {
                const inlineVideo = $(e.currentTarget);

                // Hide preview Image
                $(inlineVideo).hide();
                // Toggle content visibility
                $(inlineVideo).next('.js-inline-video').show();
            }
        });
    }
}

export default VideoWidgetInline;

$(() => {
	const videoWidgetInline = new VideoWidgetInline();
	videoWidgetInline.init();
});